import { render, staticRenderFns } from "./ClicWebCam.vue?vue&type=template&id=e80e2c78&"
import script from "./ClicWebCam.vue?vue&type=script&lang=js&"
export * from "./ClicWebCam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports